<template>
  <div class="login">
    <el-dialog
      :visible.sync="showLogin"
      :show-close="false"
      :close-on-click-modal="false"
      class="bg"
    >
      <div class="content">
        <img class="tip" :src="require('@/assets/home/tip.png')" alt="" />
        <div class="close" @click="closeDialog">+</div>
        <div class="form_card">
          <img class="logo" :src="icos[site]" alt="" />
          <p class="title">{{ $t("pc.loginInfo") }}</p>

          <div class="form">
            <div class="form_item">
              <div class="title">{{ $t("login.phoneInput") }}</div>
              <div class="box">
                <div class="select">
                  <el-dropdown trigger="click" @command="handleCommand">
                    <span class="el-dropdown-link">
                      {{ columns[phoneType].numText
                      }}<i class="el-icon-arrow-down el-icon--right"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item
                        v-for="item in columns"
                        :key="item.value"
                        :command="item.value"
                        >{{ item.text }}</el-dropdown-item
                      >
                    </el-dropdown-menu>
                  </el-dropdown>
                </div>
                <input
                  type="tel"
                  :placeholder="$t('login.phoneInput')"
                  v-model.trim="formData.account"
                  @input="formatPhone"
                  @blur="accountBlur"
                  @focus="accountErr = ''"
                />
              </div>
            </div>
            <div class="error">
              {{ accountErr }}
            </div>
            <div class="form_item">
              <div class="title">{{ $t("login.pwdInput") }}</div>
              <div class="box">
                <img
                  class="icon"
                  :src="require('@/assets/login/lock.png')"
                  alt=""
                />
                <input
                  :type="passwordInputType ? 'password' : 'text'"
                  :placeholder="$t('login.pwdInput')"
                  v-model.trim="formData.pwd"
                  @blur="pwdBlur"
                  @focus="pwdErr = ''"
                />
                <img
                  class="right"
                  :src="
                    passwordInputType
                      ? require('@/assets/login/close.png')
                      : require('@/assets/login/open.png')
                  "
                  alt=""
                  @click="passwordInputType = !passwordInputType"
                />
              </div>
            </div>
            <div class="error">{{ pwdErr }}</div>

            <div class="btn active" @click="loginSubmit">
              {{ $t("login.loginText") }}
            </div>
            <!-- <div class="btn active" @click="loginSubmit">
              {{ t("login.loginText") }}
            </div>
            <div class="btn" @click="router.push('/register/')">
              {{ t("login.registerNew") }}
            </div> -->
          </div>
        </div>
      </div>

      <SlideVerify
        v-if="showSlideVerify"
        class="slide-verify-pos"
        :h="171"
        :w="280"
        :sw="40"
        :sh="49"
        @success="verifySuccess"
        @close="showSlideVerify = false"
      />
    </el-dialog>
  </div>
</template>

<script>
import { post } from "@/util/http";
import { mapState, mapMutations, mapActions } from "vuex";
import SlideVerify from "@/components/slide-verify";

export default {
  name: "login",
  components: {
    SlideVerify,
  },
  data() {
    return {
      showSlideVerify: false,
      formData: {
        account: "",
        pwd: "",
      },
      phoneType: 0,
      passwordInputType: true,
      accountErr: "",
      pwdErr: "",
      columns: [
        {
          text: "+" + this.$t("phoneType.1"),
          numText: "+84",
          value: 0,
          test: /^(\+84|0)?(3|5|7|8|9)\d{8}$/,
          length: 9,
        },
        {
          text: "+" + this.$t("phoneType.2"),
          numText: "+63",
          value: 1,
          test: /^(\+63|0)?(9\d{2}|[2-8]\d{2})\d{7}$/,
          length: 10,
        },
        {
          text: "+" + this.$t("phoneType.3"),
          numText: "+86",
          value: 2,
          test: /^(\+?0?86\-?)?1[345789]\d{9}$/,
          length: 11,
        },
      ],
      site: SITE,
      icos: {
        onv2: require("@/assets/home/logo.png"),
        "8on": require("@/assets/home/login_8on.png"),
        sport247: require("@/assets/home/login_sport247.png"),
      },
    };
  },
  watch: {},
  mounted() {},
  computed: {
    ...mapState(["showLogin", "appConfig"]),
  },

  methods: {
    ...mapMutations(["changeLoginType", "changeUserInfo", "toggleLogin"]),
    ...mapActions(["getUserInfo"]),
    closeDialog() {
      this.toggleLogin();
      this.showSlideVerify = false;
      this.formData = {
        account: "",
        pwd: "",
      };
      this.phoneType = 0;
      this.passwordInputType = true;
      this.accountErr = "";
      this.pwdErr = "";
    },
    handleCommand(command) {
      this.phoneType = command;
    },

    //格式化用户输入的手机号
    formatPhone(e) {
      let phone = e.srcElement.value.replace(/\D+/g, "");
      if (phone.length > 3 && phone.length < 8) {
        phone = phone.replace(/^(\d{3})/g, "$1 ");
      }
      if (phone.length >= 8) {
        phone = phone.replace(/^(\d{3})(\d{4})/g, "$1 $2 ");
      }
      if (phone.length >= this.columns[this.phoneType].length + 2) {
        phone = phone.slice(0, this.columns[this.phoneType].length + 2);
      }
      this.formData.account = phone;
    },
    // 手机号校验
    accountBlur() {
      if (!this.formData.account) {
        this.accountErr = this.$t("login.phoneInput");
      } else {
        const phone = this.formData.account.replace(/\s/g, "");
        if (!this.columns[this.phoneType].test.test(phone)) {
          this.accountErr = this.$t("login.phoneCheck");
        }
      }
    },
    // 密码校验
    pwdBlur() {
      if (!this.formData.pwd) {
        this.pwdErr = this.$t("login.pwdInput");
      } else {
        if (this.formData.pwd.length < 6 || this.formData.pwd.length > 16) {
          this.pwdErr = this.$t("register.pwdRules");
        }
      }
    },
    goLogin() {
      post({
        url: "/api/user/login/new",
        data: {
          account: this.formData.account.replace(/\s/g, ""),
          pwd: this.formData.pwd,
          platform: 0,
          // login_type: this.loginType,
          source_id: 10001,
          website: window.location.host,
        },
      })
        .then(({ data }) => {
          if (data.status === 0) {
            localStorage.setItem("userInfo", JSON.stringify(data.data));
            localStorage.setItem("token", data.data.token);
            localStorage.setItem("id", data.data.id);
            this.getUserInfo();
            location.reload();
          }
        })
        .catch((err) => {});
    },
    loginSubmit() {
      this.accountErr = "";
      this.pwdErr = "";
      this.accountBlur();
      this.pwdBlur();

      if (!this.accountErr && !this.pwdErr) {
        this.goLogin();
      }
    },
  },

  created() {},
};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog {
  border-radius: 16px;
  width: 100%;
  height: 100%;
  overflow: hidden;
  margin: 0 !important;
  background-color: transparent;
}
::v-deep .el-dialog__header {
  padding: 0;
}
::v-deep .el-dialog__body {
  padding: 0;
  width: 100%;
  height: 100%;
}
::v-deep .el-input__inner {
  border: none;
  padding: 0;
}
::v-deep .el-message {
  z-index: 3000;
}
.slide-verify-pos {
  position: absolute;
  max-width: 350px;
  top: 35px;
  left: 50%;
  transform: translate3d(-50%, 10px, 10px);
  background-color: #fff;
}
.bg {
  background-image: url("~@/assets/home/login_bg.png");
  width: 6.98rem;
  height: 5.28rem;
  background-size: contain;
  background-repeat: no-repeat;
  margin: 0 auto;
  margin-top: 2rem;
}
.content {
  position: relative;
  width: 100%;
  height: 100%;
  .tip {
    position: absolute;
    top: 0.28rem;
    left: 0.28rem;
    width: 0.85rem;
    height: 0.54rem;
  }
  .close {
    position: absolute;
    top: 0.14rem;
    right: 0.14rem;
    width: 0.24rem;
    height: 0.24rem;
    cursor: pointer;
    transform: rotate(45deg);
    font-size: 0.24rem;
  }
  .form_card {
    width: 3.1rem;
    height: 4.4rem;
    border: 1px solid rgba(255, 255, 255, 0.8);
    position: absolute;
    right: 0.6rem;
    bottom: 0.44rem;
    border-radius: 0.12rem;
    padding: 0.24rem 0.2rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    .logo {
      width: 1.11rem;
      height: 0.37rem;
    }
    .title {
      margin-top: 0.24rem;
      color: rgba(51, 51, 52, 1);
      font-size: 0.16rem;
      font-weight: 500;
    }

    .form {
      width: 100%;
      .form_item {
        .title {
          color: rgba(51, 51, 52, 1);
          padding-left: 0.1rem;
          font-size: 0.12rem;
          margin-bottom: 0.04rem;
        }
        .box {
          border: 1px solid rgba(219, 219, 219, 1);
          background-color: rgba(255, 255, 255, 1);
          border-radius: 0.04rem;
          height: 0.36rem;
          width: 100%;
          padding: 0.08rem 0.1rem;
          display: flex;
          align-items: center;
          justify-content: space-between;
          .icon {
            width: 0.16rem;
            height: 0.16rem;
            margin-right: 0.02rem;
          }

          input {
            outline: none;
            border: none;
            font-size: 0.12rem;
            color: rgba(51, 51, 52, 1);
            flex: 1;
          }

          .right {
            width: 0.16rem;
            height: 0.16rem;
            margin-left: 0.02rem;
            cursor: pointer;
          }

          .select {
            /* width: 0.6rem; */
            height: 100%;
            margin-right: 0.02rem;
            border-right: 1px solid rgba(217, 217, 217, 1);
            display: flex;
            align-items: center;
            justify-content: center;
            padding-right: 0.05rem;
          }
        }
      }

      .error {
        padding: 0 0.24rem;
        height: 0.2rem;
        width: 100%;
        line-height: 0.2rem;
        color: #cf2d54;
      }
      .btn {
        margin-top: 0.4rem;
        width: 100%;
        height: 0.42rem;
        background-color: rgba(208, 45, 84, 1);
        color: rgba(255, 255, 255, 1);
        font-size: 0.14rem;
        text-align: center;
        line-height: 0.42rem;
        cursor: pointer;
      }
    }
  }
}
</style>
